import { styled } from "@mui/material/styles";
import { Stack, MenuList, MenuItem, Typography } from '@mui/material';

import { SodenarListConfig } from "./sidebar.config";
import { useCustomNavigate } from "../../provider/navigate";

export const SettingSidebar = () => {
	const { customNavigate } = useCustomNavigate();
	return (
		<SidebarWrapper>
			<MenuList>
				{SodenarListConfig.map((sidebarItem, key: number) => (
					<SidebarItemContainer onClick={customNavigate(sidebarItem.href)} key={key}>
						<Typography variant="body1">
							{sidebarItem.title}
						</Typography>
					</SidebarItemContainer>
				))}
			</MenuList>
		</SidebarWrapper >
	)
}

const SidebarWrapper = styled(Stack)(({ theme }) => ({
	width: '100%',
	maxWidth: 200,
	backgroundColor: theme.palette.common.mainBg,
	borderRight: `1px solid ${theme.palette.common.firstBorder}`,

	[theme.breakpoints.down('lg')]: {
		display: 'none',
	}
}))

const SidebarItemContainer = styled(MenuItem)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	gap: theme.spacing(1),
	padding: theme.spacing(1, 2),
	minHeight: "unset",

	p: {
		fontWeight: 500,
		color: `${theme.palette.common.firstColor}c0`,
	},
}))